import React from 'react';
import { Box, Typography, TextField, Button, InputAdornment } from '@mui/material';
import { Search as SearchIcon, Add as AddIcon, LocalHospital as HospitalIcon, Message as MessageIcon } from '@mui/icons-material';
import { styles } from '../../styles/ChemoRecordsStyles';
import { chemoTranslations } from '../../hooks/chemo/chemoTranslations';

const ChemoRecordsHeader = ({ searchTerm, onSearchChange, canCreate, onNewReport, onOpenMessage }) => {
    return (
        <Box sx={styles.headerContainer}>
            <Box sx={styles.headerContentWrapper}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: '12px', sm: '16px', md: '20px' } }}>
                    <Box sx={styles.headerIconBox}>
                        <HospitalIcon sx={{ fontSize: { xs: 24, md: 30 }, color: '#fff' }} />
                    </Box>
                    <Box>
                        <Typography variant="h4" sx={styles.headerTitle}>
                            {chemoTranslations.labels.chemoReports}
                        </Typography>
                        <Typography variant="body1" sx={styles.headerSubtitle}>
                            {chemoTranslations.labels.chemoManagement}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: { xs: '8px', sm: '12px' }, flexWrap: 'wrap' }}>
                    <TextField
                        size="small"
                        placeholder="חיפוש..."
                        value={searchTerm}
                        onChange={(e) => onSearchChange(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon sx={{ color: '#94a3b8', fontSize: 20 }} />
                                </InputAdornment>
                            )
                        }}
                        sx={{
                            minWidth: { xs: '100%', sm: '220px' },
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                backgroundColor: '#f8fafc'
                            }
                        }}
                    />

                    {onOpenMessage && (
                        <Button
                            variant="outlined"
                            startIcon={<MessageIcon />}
                            onClick={onOpenMessage}
                            sx={styles.cancelButton}
                        >
                            {chemoTranslations.table.messageToService}
                        </Button>
                    )}

                    {canCreate && (
                        <Button
                            variant="contained"
                            startIcon={<AddIcon />}
                            onClick={onNewReport}
                            sx={styles.newReportButton}
                        >
                            {chemoTranslations.labels.newReport}
                        </Button>
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default ChemoRecordsHeader;
